import type { Mission } from '../missions.ts'

export const treasury: Mission = {
  id: "treasury",
  name: "U.S. Department of the Treasury",
  short: "Treasury",
  kind: "department",
  url: "https://home.treasury.gov/",
  established: 1789,
  palette: {
    primary: "#0053a2",
    secondary: "#083c6f",
    accent: "#f4ca0e",
  },
  colorSource: {
    kind: "site",
    url: "https://home.treasury.gov/",
  },
  motif: "scales",
  mission: {
    text: "The Treasury Department is the executive agency responsible for promoting economic prosperity and ensuring the financial security of the United States.",
    url: "https://home.treasury.gov/about/general-information/role-of-the-treasury",
  },
  fact: {
    text: "Congress formally established the Treasury in 1789, but many of its functions were already being carried out before 1776.",
    url: "https://home.treasury.gov/about/history/history-overview",
  },
  seal: {
    file: "public/seals/treasury.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Department_of_the_Treasury.svg",
  },
  identifier: {
    about: "https://home.treasury.gov/about/general-information/role-of-the-treasury",
    accessibility: "https://home.treasury.gov/utility/accessibility",
    foia: "https://home.treasury.gov/footer/freedom-of-information-act",
    noFear: "https://home.treasury.gov/footer/no-fear-act",
    oig: "https://oig.treasury.gov/",
    performance: "https://home.treasury.gov/about/budget-financial-reporting-planning-and-performance/strategic-plan",
    privacy: "https://home.treasury.gov/subfooter/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/treasury-building.jpg",
        small: "/media/treasury-building-sm.jpg",
        alt: "The colonnaded east front of the Treasury Building hung with holiday garland and red bows, beside the bronze statue of Albert Gallatin.",
        title: "Treasury Building decorated for the holidays, Washington, D.C., December 7, 2010",
        creator: "U.S. Department of the Treasury",
        source: "https://commons.wikimedia.org/wiki/File:Holidays_at_the_Treasury_Department_(5242616796).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/treasury-west-point-gold.jpg",
        small: "/media/treasury-west-point-gold-sm.jpg",
        alt: "Stacks of gold bars in storage inside a vault at the West Point Mint.",
        title: "Gold bars in storage at the West Point Mint, 2011",
        creator: "United States Mint",
        source: "https://commons.wikimedia.org/wiki/File:West_Point_gold.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
    video: {
      webm: "/media/treasury-loop.webm",
      mp4: "/media/treasury-loop.mp4",
      poster: "/media/treasury-loop-poster.jpg",
      title: "West Point Quarters B-Roll: circulating quarters in production at the West Point Mint, 2019",
      creator: "United States Mint",
      source: "https://commons.wikimedia.org/wiki/File:West_Point_Quarters_B-Roll.webm",
      license: "Public domain (U.S. government work)",
    },
  },
}
